<template>
    <v-container fluid>
        <div v-html="data.content"></div>
        <gallery gallery-class="gallery" ref="gallery"></gallery>

        <banners area="content_bottom" class="mt-3"></banners>
    </v-container>
</template>

<script>
import Gallery from './views/gallery'
import Banners from './views/banners'

export default {
    mixins: [mixins],

    props: ['parent', 'login', 'config'],

    data () {
        let data = []
        let savedData = this.load('data')
        if (savedData)
            data = savedData

        return {
            data
        }
    },

    components: {
        Gallery,
        Banners
    },

    created () {
        this.checkLogin()
        this.getData()
        this.changeNavbar()
    },

    methods: {
        getData () {
            let id = this.config
            axios.get('/content-pages/data/' + id)
                .then(response => {
                    this.data = response.data
                    this.save('data', this.data)
                })
        }
    },

    watch: {
        data () {
            if (this.$refs.gallery) {
                this.$nextTick(() => {
                    this.$refs.gallery.init()
                })
            }
        }
    }
}
</script>
